import React from "react";

import PropTypes from "prop-types";
import config from "config";

function getItemFromLocalStorage(key) {
  return JSON.parse(window.localStorage.getItem(key));
}

/*
 * Find and replace variables in translation.
 * More details here: https://docs.lokalise.co/developer-docs/universal-placeholders
 */
function replaceVariables(translation, variables) {
  if (variables && !Object.keys(variables)?.length) {
    return translation;
  }

  return translation.replace(/\[%s:([\w-_]+?)\]/g, (match, key) => {
    if (key in variables) {
      return variables[key];
    }
    console.warn(`There is no variable for key "${key}" in "${translation}"`);
    return "";
  });
}

function getKeyHelper(key, env) {
  if (key !== "" && env !== "prod" && config.showTranslateErrors) {
    console.error(`Key "${key}" not found`);
  }

  return key;
}

export function getTranslate(key, variables, notranslate) {
  const langsData = getItemFromLocalStorage("strings_langs");
  const env = "prod";

  if (notranslate || !langsData) {
    return key;
  }

  const string = langsData && langsData.find((item) => item.key === key);
  return string && string.translation
    ? replaceVariables(string.translation, variables)
    : getKeyHelper(key, env);
}

const Translate = ({ tag, variables, notranslate }) => (
  <span
    dangerouslySetInnerHTML={{
      __html: getTranslate(tag, variables, notranslate),
    }}
  />
);

Translate.propTypes = {
  tag: PropTypes.string.isRequired,
  variables: PropTypes.object,
  notranslate: PropTypes.bool,
};

Translate.defaultProps = {
  variables: {},
  notranslate: false,
};

export default Translate;
